import React from "react";
import { Asterisk } from "lucide-react";
import api from "~/services/api";

export const sections = [
  { kind: "templates", alias: "messages-templates", title: "Templates", path: "/Administrative/Messages/Templates", icon: "Files" },
  { kind: "campaigns", alias: "messages-campaigns", title: "Campaigns", path: "/Administrative/Messages/Campaigns", icon: "Megaphone" },
  { kind: "history", alias: "messages-history", title: "History", path: "/Administrative/Messages/History", icon: "History" },
  { kind: "quick-message", alias: "messages-quick-message", title: "Quick message", path: "/Administrative/Messages/QuickMessage", icon: "Zap" },
];

export function messageSectionAccess(accesses, alias) {
  const administrative = accesses?.hierarchy?.find((item) => item.alias === "administrative");
  const messages = administrative?.children?.find((item) => item.alias === "messages");
  return messages?.children?.find((item) => item.alias === alias);
}

export const categories = [
  ["emergency", "Emergency"],
  ["financial", "Financial"],
  ["academic", "Academic"],
  ["institutional", "Institutional"],
  ["marketing", "Marketing / promotion"],
  ["relationship", "Relationship"],
];

export const fieldClass = "w-full border rounded-xs p-2 px-2 text-sm bg-white outline-hidden focus:border-mila_orange disabled:bg-slate-100 disabled:text-gray-500";
export const buttonClass = "cursor-pointer text-md font-bold bg-secondary border transition-colors hover:border-mila_orange hover:text-mila_orange hover:bg-orange-50 rounded-md px-4 h-8 flex flex-row items-center justify-center text-xs gap-1 disabled:opacity-40 disabled:cursor-not-allowed";
export const primaryButtonClass = "text-md font-bold bg-primary text-white rounded-md px-4 h-8 flex flex-row items-center justify-center text-xs gap-1 disabled:opacity-50 disabled:cursor-not-allowed";
export const labelCategory = (value) => categories.find(([key]) => key === value)?.[1] || value || "";
export const labelChannel = (value) => ({ email: "Email", sms: "SMS", push: "Mobile notification", inbox: "Internal app inbox" }[value] || value);
export const dateLabel = (value) => value && !Number.isNaN(new Date(value).getTime()) ? new Date(value).toLocaleString() : "";
export const errorText = (error) => error?.response?.data?.error || "Unable to load or save this record. Please try again.";

export function messagingRequest(branchId, method, url, data, signal, params) {
  return api.request({ method, url, data, signal, params, messagingFilialId: branchId });
}

export function Status({ value }) {
  const style = value === "active" ? "bg-green-50 text-green-700" : value === "archived" ? "bg-gray-100 text-gray-500" : "bg-orange-50 text-orange-700";
  return <span className={"inline-block rounded-full px-2 py-1 text-xs " + style}>{({ draft: "Draft", active: "Active", archived: "Archived", confirmed: "Confirmed" })[value] || value || ""}</span>;
}

export function Field({ label, required = false, children, className = "" }) {
  return <label className={"flex min-w-0 flex-1 flex-col items-start justify-center text-xs w-full md:w-auto " + className}>
    <span className="px-1 flex flex-row items-center gap-1">{label}{required && <Asterisk color="#e00" size={12} />}</span>
    {children}
  </label>;
}

export function Section({ title, children }) {
  return <div className="w-full min-w-0 px-4">
    {title && <h1 className="w-full border-b pb-2 font-bold">{title}</h1>}
    <div className="flex flex-col gap-4 w-full min-w-0 py-4">{children}</div>
  </div>;
}

export function Row({ children }) {
  return <div className="flex flex-col md:flex-row items-start gap-4 w-full">{children}</div>;
}
